export enum DistributionPolygonColor {
    Collection = "black",
    Transport = "green",
    Library = "orange",
    Packages = "red",
    Default = "blue"
  }